<template>
    <ul :class="oldDisplay ? 'profile-languages-old' : 'profile-languages'">
        <li
            v-for="(language, index) in languages"
            :key="language.code"
            :class="oldDisplay ? 'profile-languages-old__item' : 'profile-languages__item'"
        >
            <p
                :class="oldDisplay ? 'profile-languages-old__item__title' : 'profile-languages__item__title'"
                :data-testid="`profile-language-name-${index}`"
            >
                {{ getLocalizedLanguageName(language.code, language.name ?? t('generic.unknown')) }}
            </p>
            <p
                :class="oldDisplay ? 'profile-languages-old__item__subtitle' : 'profile-languages__item__subtitle'"
                :data-testid="`profile-language-level-${index}`"
            >
                {{ t(`profile.new.language.level.${language.level}`) }}
            </p>
        </li>
    </ul>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useLanguageFormatter, useTranslation} from '#imports';
    import {useFeatureFlag} from '@malt/feature-flags';
    import type {LanguageItem} from '~/components/_common/language/LanguageItem';

    const isProfileRevampDrawerEnabled = useFeatureFlag('profile-revamp-drawer');

    const {t} = useTranslation();
    const {getLocalizedLanguageName} = useLanguageFormatter();

    export interface Props {
        languages?: LanguageItem[];
        mf?: boolean;
    }

    const props = withDefaults(defineProps<Props>(), {
        languages: () => [],
        mf: false,
    });

    const oldDisplay = computed(() => props.mf && !isProfileRevampDrawerEnabled.value);
</script>

<style lang="scss">
    .profile-languages-old {
        list-style-type: none;
        padding: 0;
        margin-top: var(--joy-core-spacing-2);

        &__item {
            padding: var(--joy-core-spacing-4);
            margin-bottom: var(--joy-core-spacing-2);

            &:last-child {
                margin-bottom: 0;
                padding-bottom: 0;
            }

            &__title {
                font-family: var(--joy-font-family-base);
                font-weight: var(--joy-font-weight-bold);
                font-size: var(--joy-font-size-primary-600);
                line-height: var(--joy-line-height-large);
                margin-bottom: 0;
            }

            &__subtitle {
                font-size: var(--joy-font-size-primary-300);
                margin-bottom: var(--joy-core-spacing-1);
                color: var(--joy-color-text-default);
            }
        }
    }

    .profile-languages {
        list-style-type: none;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        flex-grow: 1;
        gap: var(--joy-core-spacing-2) var(--joy-core-spacing-8);
        margin-top: 0;
        margin-bottom: 0;

        &__item {
            &__title {
                font-size: var(--joy-font-size-primary-300);
                font-weight: var(--joy-font-weight-bold);
                margin-bottom: 0;
            }

            &__subtitle {
                font-size: var(--joy-font-size-primary-300);
                margin-top: var(--joy-core-spacing-1);
                margin-bottom: var(--joy-core-spacing-1);
                color: var(--joy-color-text-default);
            }
        }
    }
</style>
